// import InfoIcon from '@material-ui/icons/Info';
import React from 'react';
import styled from 'styled-components';

import ToggleSlider from '#/components/basic/inputs/ToggleSlider/ToggleSlider';
import config from '#/config';
// import Tooltip from '#/components/basic/tooltip/Tooltip';

const CheckboxWrap = styled.div`
  display: flex;
  justify-content: center;
  /* align-items: center;
  gap: 8px; */
  font-size: var(--small);
`;

// const Flex = styled.div`
//   display: flex;
//   gap: 4px;
// `;

// const InfoIconWrap = styled.div`
//   display: inline-block;
//   position: relative;
//   bottom: -2px;
//   color: var(--gray4b);
// `;

// function InfoBubble({ tooltipText }: { tooltipText: string }) {
//   return (
//     <Tooltip text={tooltipText} maxWidthPx={230}>
//       <InfoIconWrap>
//         <InfoIcon fontSize="inherit" />
//       </InfoIconWrap>
//     </Tooltip>
//   );
// }

export default function RememberMe({
  disabled,
  remember,
  onChange,
}: {
  disabled: boolean;
  remember: boolean;
  onChange: (remember: boolean) => void;
}) {
  return (
    <CheckboxWrap>
      {/* <Flex>
        <div>Stay logged in for {config.delegatedKeyExpirationDays} days</div>
      </Flex> */}
      <ToggleSlider checked={remember} onChange={onChange} disabled={disabled}>
        Stay logged in for {config.delegatedKeyExpirationDays} days
      </ToggleSlider>
    </CheckboxWrap>
  );
}
